import { jsx as r } from "react/jsx-runtime";
import { Component as e } from "react";
import { ErrorView as t } from "./ErrorView.js";
import { ERROR_MESSAGES as o } from "./utils.js";
import { AppEvents as n } from "../../utils/appEventBus/eventMap.js";
import { appEventBus as a } from "../../utils/appEventBus/appEventBus.js";
class i extends e {
  constructor(r2) {
    super(r2), this.state = { ...o.UNKNOWN, hasError: false }, this.__handleVitePreloadError = this.__handleVitePreloadError.bind(this), this.__handleInternalServerError = this.__handleInternalServerError.bind(this);
  }
  __handleVitePreloadError() {
    this.setState({ ...o.ROUTER, hasError: true }), setTimeout(() => window.location.reload(), 1e3);
  }
  __handleInternalServerError() {
    this.setState({ ...o.UNKNOWN, hasError: true });
  }
  componentDidMount() {
    window.addEventListener(n.vitePreloadError, this.__handleVitePreloadError), window.addEventListener(n.InternalServerErrorEvent, this.__handleInternalServerError);
  }
  componentWillUnmount() {
    window.removeEventListener(n.vitePreloadError, this.__handleVitePreloadError), window.removeEventListener(n.InternalServerErrorEvent, this.__handleInternalServerError);
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(r2, e2) {
    console.error("ErrorBoundary Error: ", r2, e2.componentStack), this.setState({ ...o.UNKNOWN, hasError: true });
  }
  render() {
    return this.state.hasError ? (a.emit(n.LoadingStateEvent, false), r(t, { hideHeader: true, ...this.state })) : this.props.children || null;
  }
}
export {
  i as ErrorBoundary,
  i as default
};
//# sourceMappingURL=index.js.map
